import 'arrayq';
import { put, take, takeEvery } from '@zaibot/fsa-saga';
import { fork, select } from '../../redux-saga';
import { IBookmark, IQuestionDB } from '../../types';

import { selectors as metaSelectors } from '../../meta/selectors';
import { bookmarksEditor, bookmarksResource } from '../bookmarks/resource';
import { notesEditor, notesResource } from '../notes/resource';
import selectionSelectors from '../selection/selectors';

import FLYOVER_HIDE from '../flyover/actions/HIDE';
import BUTTON_HIDE_FLYOVER from '../flyover/actions/BUTTON_HIDE_FLYOVER';
import FLYOVER_SHOW from '../flyover/actions/SHOW';
import NOTEMENU_ERASE from '../notemenu/actions/ERASE';
import SELECTION_RESET from '../selection/actions/RESET';
import SELECTION_SUCCESS from '../selection/actions/SUCCESS';
import UPDATE_BUTTON_NO, { originFlyover } from '../../focuslock/actions/UPDATE_BUTTON_NO';
import { buttonBekijkItems } from '../../focuslock/actions/UPDATE_BUTTON_NO';
import { getPageId } from '../../settings';
import { SelectEffect, TakeEffect } from 'redux-saga/effects';
import { categoriesResource } from '../categories/resource';
import { notechatEditor, notechatResource } from '../notechat/resource';
import { questionsEditor, questionsResource } from '../question/resource';
export function* rootSaga(): Iterable<any> {
    // yield fork(signalHideFlyover);
    yield fork(signalButtonHideFlyover);
    yield fork(signalHideNoteMenu);
    yield fork(signalNotesRequest);
    yield fork(signalSelectionReset);
    // yield fork(signalShowFlyover);
    yield fork(signalReadNote);
    yield fork(signalReadBookmark);
    yield fork(signalReadCategory);
    yield fork(signalQuestion);
}

function* signalButtonHideFlyover() {
    yield takeEvery([BUTTON_HIDE_FLYOVER], function*() {
        yield put(FLYOVER_HIDE({}));
        yield put(UPDATE_BUTTON_NO({buttonNo: buttonBekijkItems, origin: originFlyover }));
    });
}

function* signalHideNoteMenu() {
    yield takeEvery(FLYOVER_SHOW, function*(action) {
        yield put(NOTEMENU_ERASE({}));
    });
}

function* signalSelectionReset() {
    yield takeEvery(FLYOVER_SHOW, function*() {
        const creatingSelectionEff: SelectEffect = yield select(selectionSelectors.creating);
        const creatingSelection: any = creatingSelectionEff;
        if (creatingSelection) {
            yield put(SELECTION_RESET({}));
        }
    });
}

function* signalReadNote() {
    while (true) {
        
        const updateEff: TakeEffect = yield take(notesEditor.actions.UPDATE);
        const update: any = updateEff;
        const resolveEff: TakeEffect = yield take([
            notesEditor.actions.UPDATE_CANCEL,
            notesResource.actions.UPDATE_SUCCESS,
            notesResource.actions.UPDATE_FAILURE,
            notesEditor.actions.RESET,
        ]);
        const resolve = resolveEff;
        if (resolve) {
            const pageIdEff: TakeEffect = yield select(metaSelectors.pageId);
            const pageId: any = pageIdEff;
            if (update.payload.item.pageId === pageId) {
                yield put(notesEditor.actions.READ({ item: update.payload.item }));           
            }
        }
    }
}

function* signalQuestion() {
    while (true) {        
        const updateEff: TakeEffect = yield take(questionsEditor.actions.UPDATE);
        const update: any = updateEff;
        const resolveEff: TakeEffect = yield take([
            questionsEditor.actions.UPDATE_CANCEL,
            questionsResource.actions.UPDATE_SUCCESS,
            questionsResource.actions.UPDATE_FAILURE,
            questionsEditor.actions.RESET,
        ]);
        const resolve = resolveEff;
        if (resolve) {
            var readquestion = false;
            const questions: IQuestionDB[] = yield select(questionsResource.selectors.items);
            var current = questions.qWhere((x) => x.id === update.payload.item.id).qFirst();
            if (current) {          
                yield put(questionsEditor.actions.READ({ item: current })); 
                readquestion = true; 
            }
        } 
        if (!readquestion) {
            yield put(questionsEditor.actions.READ_CANCEL({}));
        }                  
    }
}

function* signalReadBookmark() {
    yield takeEvery<any, any>([
        bookmarksResource.actions.LIST_SUCCESS,
        bookmarksResource.actions.CREATE_SUCCESS,
        bookmarksResource.actions.READ_SUCCESS,
        bookmarksResource.actions.UPDATE_SUCCESS,
        bookmarksResource.actions.DELETE_SUCCESS,
    ], function*() {
        const bookmarks: IBookmark[] = yield select(bookmarksResource.selectors.items);
        const pageIdEff: TakeEffect = yield select(metaSelectors.pageId);
        const pageId: any = pageIdEff;
        const current = bookmarks.qWhere((x) => x.pageId === pageId).qFirst();
        if (current) {
            yield put(bookmarksEditor.actions.READ({ item: current }));
        }
    });
}
function* signalReadCategory() {
    yield takeEvery<any, any>([
        categoriesResource.actions.CREATE_SUCCESS,
    ], function*(action) {
        yield put(categoriesResource.actions.READ({ item: action.payload.item }));
    });
}
function* signalNotesRequest() {
    yield takeEvery(SELECTION_SUCCESS, function*(action) {
        const selectionDocument: SelectEffect = yield select(metaSelectors.docId);
        const selectionDocumentId: any = selectionDocument;
        const docId = selectionDocumentId;
        const pageId = getPageId(); // yield select(metaSelectors.pageId);
        
        yield put(notesEditor.actions.CREATE({
            item: {
                categoryId: null,
                documentId: docId,
                endCharacter: 0,
                endElementXPath: action.payload.end,
                pageId,
                pageState: 'null',
                startCharacter: 0,
                startElementXPath: action.payload.start,
                text: '',
                isquestion: !action.payload.isnote,
            },
        }));    

        if (!action.payload.isnote) {
            yield put(questionsEditor.actions.CREATE({
                item: {
                    documentId: docId,
                    status: 1,    
                    antwoordConcern: '',   
                    practicionerId: undefined,
                },
            }));  
        }
    });
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/ui/sagas.tsx